// extracted by mini-css-extract-plugin
module.exports = {"splitter":"ObjectsFilterMobile_splitter__6B1Qw","actions":"ObjectsFilterMobile_actions__6bXHH"};